var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.tooltip),expression:"tooltip"}],staticClass:"flex items-center justify-center font-bold p-0.5 text-sm my-auto self-center",class:{
    hidden: _vm.showOnlyIfLocked && !_vm.locked,
    'inline-flex': !_vm.showOnlyIfLocked
  }},[_c('fa-icon',{staticClass:"ml-1 text-gray-500 dark:text-neutral-400 fa-fw",attrs:{"icon":_vm.locked ? 'lock' : 'lock-open',"size":"sm"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }